"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _reactApollo = require("react-apollo");

var _BasicProfile = _interopRequireDefault(require("../components/BasicProfile"));

var _Organisation = _interopRequireDefault(require("../../../contexts/Organisation"));

var _basePath = _interopRequireDefault(require("../../../../../common/constants/basePath"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function BasicProfile(_ref) {
  var goToNextWizardStage = _ref.goToNextWizardStage;
  return _react.default.createElement(_Organisation.default.Consumer, null, function (_ref2) {
    var _ref2$state = _ref2.state,
        organisation = _ref2$state.organisation,
        organisations = _ref2$state.organisations,
        hasUpdatePermission = _ref2$state.hasUpdatePermission,
        updateOrganisation = _ref2.actions.updateOrganisation;
    return _react.default.createElement(_reactApollo.ApolloConsumer, null, function (apolloClient) {
      return _react.default.createElement(_BasicProfile.default, {
        goToNextWizardStage: goToNextWizardStage,
        organisation: organisation,
        organisations: organisations,
        updateOrganisation: updateOrganisation,
        apolloClient: apolloClient,
        hasUpdatePermission: hasUpdatePermission
      });
    });
  });
}

var _default = (0, _withBasedRouter.default)(_basePath.default, BasicProfile);

exports.default = _default;